import { useSelector } from 'react-redux';
import { RootState } from '@nxsys/store';

const EMPLOYEES_POLICY = 'CompanyEmployees';

/**
 * The dashboard "Action Required" popups drill down into employee/subcontractor
 * records (name, email, NI/PPS number, recurring payments…), so opening them is
 * gated on the same policy as the Employees module. A user who can only view
 * the dashboard (holds CompanyDashboard but not CompanyEmployees) sees the
 * alert counts but cannot open the list popup — mirroring the menu/route
 * visibility enforced for the Employees page in NX-5440.
 */
export const useCanAccessEmployees = (): boolean => {
  const policies = useSelector((state: RootState) => state.appStore.policies);
  return policies?.includes(EMPLOYEES_POLICY) ?? false;
};
